import { __rest } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import CaretDown from '../../../icons/CaretDown.esm.js';
import { NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import styles from './StepperHoverItem.module.esm.js';

var StepperHoverItem = function (_a) {
    var _b;
    var id = _a.id, _c = _a.fields, heading = _c.heading, body = _c.body, rest = __rest(_a, ["id", "fields"]);
    var _d = rest, handleSelected = _d.handleSelected, isSelected = _d.isSelected;
    var itemClasses = classNames(styles.item, (_b = {},
        _b[styles.selected] = id === isSelected ? 'selected' : '',
        _b));
    return (React.createElement("div", { className: itemClasses, id: id, role: "listitem" },
        React.createElement("button", { className: styles.header, onFocus: function () { return handleSelected(id); }, onMouseEnter: function () { return handleSelected(id); } },
            React.createElement(NvMarkdownInline, { className: styles.heading, element: "h3", elementWrapper: NvHeading, level: 3 }, heading),
            React.createElement("div", { className: classNames(styles.caret) },
                React.createElement(CaretDown, null))),
        body && (React.createElement("div", { className: styles.bodyContainer },
            React.createElement(NvMarkdown, { className: classNames(styles.bodyContent) }, body)))));
};

export { StepperHoverItem as default };
//# sourceMappingURL=StepperHoverItem.esm.js.map
